import React from 'react';

const TelemetryIllustration = ({ type = "map" }) => {
  return (
    <div className="w-full h-full bg-[#050508] rounded-lg border border-[#1a1a2e] relative overflow-hidden flex items-center justify-center group">
      {/* Grid Lines */}
      <div className="absolute inset-0 opacity-20" style={{ 
        backgroundImage: 'linear-gradient(#1a1a2e 1px, transparent 1px), linear-gradient(90deg, #1a1a2e 1px, transparent 1px)',
        backgroundSize: '20px 20px'
      }}></div>

      {type === "map" && (
        <svg className="w-4/5 h-4/5 opacity-40 group-hover:opacity-60 transition-opacity" viewBox="0 0 100 100">
          <path d="M10 10 L90 10 L90 90 L10 90 Z" fill="none" stroke="#00f0ff" strokeWidth="0.5" strokeDasharray="2 2" />
          <path d="M30 10 V90 M60 10 V90 M10 30 H90 M10 60 H90" stroke="#1a1a2e" strokeWidth="0.5" />
          <circle cx="45" cy="45" r="1.5" fill="#00f0ff" />
          <circle cx="45" cy="45" r="8" stroke="#00f0ff" strokeWidth="0.5" fill="rgba(0,240,255,0.05)" />
          <path d="M45 45 L65 30" stroke="#ff5500" strokeWidth="1" strokeDasharray="2 1" />
          <rect x="63" y="28" width="4" height="4" fill="#ff5500" />
        </svg>
      )}

      {type === "engine" && (
        <svg className="w-3/5 h-3/5 opacity-40 group-hover:opacity-60 transition-opacity" viewBox="0 0 100 100">
          <path d="M20 50 Q50 20 80 50 Q50 80 20 50" fill="none" stroke="#00f0ff" strokeWidth="1" />
          <circle cx="50" cy="50" r="15" stroke="#00f0ff" strokeWidth="2" strokeDasharray="4 2" />
          <path d="M50 35 V20 M50 65 V80 M35 50 H20 M65 50 H80" stroke="#00f0ff" strokeWidth="1" />
        </svg>
      )}

      {type === "report" && (
        <div className="flex flex-col gap-2 w-1/2">
          <div className="h-2 w-full bg-[#1a1a2e] rounded-full overflow-hidden">
            <div className="h-full bg-[#00f0ff] w-3/4 animate-pulse"></div>
          </div>
          <div className="h-2 w-4/5 bg-[#1a1a2e] rounded-full overflow-hidden">
            <div className="h-full bg-[#ff5500] w-1/2"></div>
          </div>
          <div className="h-2 w-full bg-[#1a1a2e] rounded-full overflow-hidden">
            <div className="h-full bg-green-500 w-4/5"></div>
          </div>
        </div>
      )}

      <div className="absolute bottom-2 right-2 text-[8px] font-mono text-[#00f0ff]/50 uppercase tracking-tighter">
        Telemetry_Module_v2.4
      </div>
    </div>
  );
};

export default TelemetryIllustration;